import API_END_POINTS from '@/api/endpoints';
import { dataFetch } from '@/api/data-fetch';
import saveDataInLocalStorage from '@/utils/saveDataInLocalStorage';
import { selectionsTransformation } from '../helpers/index.js';

export default {
  async fetchPredictorData({ commit }, { eventId, isHandleReset = false, fetcher = dataFetch }) {
    try {
      const urlOfPredictorMeta = `${API_END_POINTS.PREDICTOR.META}&eventId=${eventId}`;
      const urlOfPredictorData = `${API_END_POINTS.PREDICTOR.DATA}&eventId=${eventId}`;
      const promiseOfPredictorMeta = await fetcher(urlOfPredictorMeta);
      const promiseOfPredictorData = await fetcher(urlOfPredictorData);
      const promises = [promiseOfPredictorMeta, promiseOfPredictorData];
      const slidersDataInLocalStorage = JSON.parse(localStorage.getItem('predictor-sliders'));

      Promise.all(promises).then(results => {
        if (results.length === promises.length) {
          const { direction, railPosition } = results[0];
          const { selections, sliders } = results[1];
          const updatedSelections = selectionsTransformation({ selections, sliders });
          commit('SET_RAIL_POSITION', { railPosition });
          commit('SET_SELECTIONS', { selections: updatedSelections });
          commit('SET_DIRECTION', { direction });
          if (!isHandleReset) {
            if (!slidersDataInLocalStorage) {
              commit('SET_SLIDERS', { sliders });
              saveDataInLocalStorage({
                itemName: 'predictor-sliders',
                data: sliders,
              });
            } else {
              commit('SET_SLIDERS', { sliders: slidersDataInLocalStorage });
            }
          }

          if (isHandleReset) {
            commit('SET_SLIDERS', { sliders });
            saveDataInLocalStorage({
              itemName: 'predictor-sliders',
              data: sliders,
            });
            commit('SET_SELECTED_PRESET_ID', { id: null });
          }
        }
      });
    } catch (error) {
      console.log(error);
    }
    commit('SET_LOADING_STATUS');
  },
  async fetchPresetData({ state, commit }, { env = 'prod', fetcher = dataFetch }) {
    try {
      const url = `${API_END_POINTS.PREDICTOR.PRESET({ env }).GET_DATA}`;
      const { settings } = await fetcher(url);
      if (Array.isArray(settings)) {
        const presetData = settings.map(item => {
          return {
            ...item,
            selected: state.selectedPresetId === item.id,
          };
        });
        commit('SET_PRESET_DATA', { presetData });
      }
    } catch (error) {
      console.log(error);
    }
  },
  async addPresetData({ state, commit }, { env = 'prod', presetName, fetcher = dataFetch }) {
    try {
      let queryParam = `name=${presetName}`;
      state.sliders.map(({ key, defaultValue }) => {
        queryParam = `${queryParam}&${key}=${defaultValue}&`;
      });
      const url = `${API_END_POINTS.PREDICTOR.PRESET({ env }).SAVE_DATA}&${queryParam}`;
      const result = await fetcher(url);
      const { success, id } = result;
      if (success === true) {
        commit('SET_SELECTED_PRESET_ID', { id: parseInt(id) });
      }
    } catch (error) {
      console.error(error);
    }
  },
  deletePresetData(state, { env = 'prod', presetIds, fetcher = dataFetch }) {
    try {
      const promises = presetIds.map(async presetId => {
        const url = `${API_END_POINTS.PREDICTOR.PRESET({ env }).DELETE_DATA}&predictorId=${presetId}`;
        return await fetcher(url);
      });
      Promise.all(promises);
    } catch (error) {
      console.log(error);
    }
  },
};
